/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeploymentAndConfigUpdateDetails } from './deploymentAndConfigUpdateDetails';


export interface OrgDeploymentDetails { 
    /**
     * Organisation Id.
     */
    org_id?: string;
    /**
     * Number of total deployments for organisation Id.
     */
    total_deployments?: number;
    deployments?: Array<DeploymentAndConfigUpdateDetails>;
}

